import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { colors } from '../Colors';
import LoginModal from './layout/LoginModal';

function Navigation() {
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isProjectsDropdownOpen, setIsProjectsDropdownOpen] = useState(false);
  const [isGalleryDropdownOpen, setIsGalleryDropdownOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
    }
  };

  const isProjectsActive = location.pathname.startsWith('/audio') || location.pathname.startsWith('/seance');
  const isGalleryActive = location.pathname === '/musics' || location.pathname === '/images-gallery';

  const toggleProjectsDropdown = () => {
    setIsProjectsDropdownOpen(!isProjectsDropdownOpen);
    setIsGalleryDropdownOpen(false); // Close gallery dropdown when opening projects
  };

  const closeProjectsDropdown = () => {
    setIsProjectsDropdownOpen(false);
  };

  const toggleGalleryDropdown = () => {
    setIsGalleryDropdownOpen(!isGalleryDropdownOpen);
    setIsProjectsDropdownOpen(false); // Close projects dropdown when opening gallery
  };

  const closeGalleryDropdown = () => {
    setIsGalleryDropdownOpen(false);
  };

  return (
    <header style={{
      background: colors.gradients.primary, 
      color: 'white', 
      padding: '2px 0 5px 0',
      boxShadow: '0 1px 5px rgba(0,0,0,0.1)',
      position: 'sticky',
      top: 0,
      zIndex: 1000
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '6px' }}>
          <div>
            <h1 style={{ 
              fontSize: '1.1rem', 
              fontWeight: '700', 
              marginBottom: '0px',
              background: 'linear-gradient(45deg, #F39C12, #E74C3C)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}>
              Interface Torah IA
            </h1>
            <p style={{ fontSize: '0.6rem', opacity: '0.9', fontWeight: '300' }}>
              Création de contenu éducatif pour enfants
            </p>
          </div>
          
          <nav style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', alignItems: 'center' }}>
            <Link to="/" style={{
              background: location.pathname === '/' ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.1)',
              color: 'white',
              border: '2px solid transparent',
              padding: '3px 10px',
              fontSize: '0.75rem',
              fontWeight: '600',
              borderRadius: '14px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              textDecoration: 'none'
            }}>
              🏠 Accueil
            </Link>
            <Link to="/image" style={{
              background: location.pathname === '/image' ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.1)',
              color: 'white',
              border: '2px solid transparent',
              padding: '3px 10px',
              fontSize: '0.75rem',
              fontWeight: '600',
              borderRadius: '14px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              textDecoration: 'none'
            }}>
              🖼️ Traitement d'image
            </Link>
            <Link to="/paracha" style={{
              background: location.pathname === '/paracha' ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.1)',
              color: 'white',
              border: '2px solid transparent',
              padding: '3px 10px',
              fontSize: '0.75rem',
              fontWeight: '600',
              borderRadius: '14px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              textDecoration: 'none'
            }}>
              📖 Parachot
            </Link>
            
            {/* Gallery Dropdown */}
            <div style={{ position: 'relative' }}>
              <button
                onClick={toggleGalleryDropdown}
                style={{
                  background: isGalleryActive ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.1)',
              color: 'white',
              border: '2px solid transparent',
              padding: '3px 10px',
              fontSize: '0.75rem',
              fontWeight: '600',
              borderRadius: '14px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(255,255,255,0.2)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = isGalleryActive ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.1)';
                }}
              >
                🖼️ Galerie
                <span style={{ fontSize: '0.6rem', transform: isGalleryDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }}>
                  ▼
                </span>
              </button>
              
              {/* Gallery Dropdown Menu */}
              {isGalleryDropdownOpen && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  left: '0',
                  marginTop: '4px',
                  backgroundColor: 'white',
                  borderRadius: '8px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                  border: '1px solid #E0E0E0',
                  minWidth: '180px',
                  zIndex: 1001
                }}>
                  <Link 
                    to="/musics" 
                    onClick={closeGalleryDropdown}
                    style={{
                      display: 'block',
                      padding: '8px 16px',
                      color: '#2C3E50',
                      textDecoration: 'none',
                      fontSize: '0.75rem',
                      fontWeight: '600',
                      borderBottom: '1px solid #F0F0F0',
                      transition: 'background-color 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = '#F8F9FA';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                    }}
                  >
              🎵 Musiques
            </Link>
                  <Link 
                    to="/images-gallery" 
                    onClick={closeGalleryDropdown}
                    style={{
                      display: 'block',
                      padding: '8px 16px',
                      color: '#2C3E50',
                      textDecoration: 'none',
                      fontSize: '0.75rem',
                      fontWeight: '600',
                      transition: 'background-color 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = '#F8F9FA';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                    }}
                  >
                    🖼️ Images
                  </Link>
                </div>
              )}
            </div>
            
            {/* Projects Dropdown */}
            <div style={{ position: 'relative' }}>
              <button
                onClick={toggleProjectsDropdown}
                style={{
                  background: isProjectsActive ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.1)',
                  color: 'white',
                  border: '2px solid transparent',
                  padding: '3px 10px',
                  fontSize: '0.75rem',
                  fontWeight: '600',
                  borderRadius: '14px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(255,255,255,0.2)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = isProjectsActive ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.1)';
                }}
              >
                📁 Nos projets
                <span style={{ fontSize: '0.6rem', transform: isProjectsDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }}>
                  ▼
                </span>
              </button>
              
              {/* Dropdown Menu */}
              {isProjectsDropdownOpen && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  left: '0',
                  marginTop: '4px',
                  backgroundColor: 'white',
                  borderRadius: '8px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                  border: '1px solid #E0E0E0',
                  minWidth: '180px',
                  zIndex: 1001
                }}>
                  <Link 
                    to="/audio" 
                    onClick={closeProjectsDropdown}
                    style={{
                      display: 'block',
                      padding: '8px 16px',
                      color: '#2C3E50',
                      textDecoration: 'none',
                      fontSize: '0.75rem',
                      fontWeight: '600',
                      borderBottom: '1px solid #F0F0F0',
                      transition: 'background-color 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = '#F8F9FA';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                    }}
                  >
                    🎵 Pipeline audio
                  </Link>
                  <Link 
                    to="/seance" 
                    onClick={closeProjectsDropdown}
                    style={{
                      display: 'block',
                      padding: '8px 16px',
                      color: '#2C3E50',
                      textDecoration: 'none',
                      fontSize: '0.75rem',
                      fontWeight: '600',
                      transition: 'background-color 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = '#F8F9FA';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                    }}
                  >
                    🎓 Séances
                  </Link>
                </div>
              )}
            </div>
            
            {user ? (
              <>
                <div style={{
                  background: 'rgba(255,255,255,0.1)',
                  color: 'white',
                  border: '2px solid transparent',
                  padding: '3px 10px',
                  fontSize: '0.75rem',
                  fontWeight: '600',
                  borderRadius: '14px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px'
                }}>
                  <span style={{ fontSize: '0.7rem' }}>👤</span>
                  <span style={{ maxWidth: '120px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {user.email}
                  </span>
                </div>
                <button
                  onClick={handleLogout}
                  style={{
                    background: 'rgba(231, 76, 60, 0.8)',
                    color: 'white',
                    border: '2px solid transparent',
                    padding: '3px 10px',
                    fontSize: '0.75rem',
                    fontWeight: '600',
                    borderRadius: '14px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = 'rgba(231, 76, 60, 1)';
                    e.target.style.transform = 'translateY(-1px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'rgba(231, 76, 60, 0.8)';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  <span style={{ fontSize: '0.7rem' }}>🚪</span>
                  Déconnecter
                </button>
              </>
            ) : (
              <button
                onClick={() => setIsLoginModalOpen(true)}
                style={{
                  background: 'rgba(255,255,255,0.2)',
                  color: 'white',
                  border: '2px solid rgba(255,255,255,0.3)',
                  padding: '5px 12px',
                  fontSize: '0.75rem',
                  fontWeight: '600',
                  borderRadius: '14px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(255,255,255,0.3)';
                  e.target.style.transform = 'translateY(-1px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'rgba(255,255,255,0.2)';
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                <span style={{ fontSize: '0.8rem' }}>🔐</span>
                Connexion
              </button>
            )}
          </nav>
        </div>
      </div>
      
      {/* Overlay to close dropdowns when clicking outside */}
      {(isProjectsDropdownOpen || isGalleryDropdownOpen) && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1000
          }}
          onClick={() => {
            closeProjectsDropdown();
            closeGalleryDropdown();
          }}
        />
      )}
      <LoginModal 
        isOpen={isLoginModalOpen} 
        onClose={() => setIsLoginModalOpen(false)} 
      />
    </header>
  );
}

export default Navigation;